'use client';

import { c as _c } from "react/compiler-runtime";
import { Toaster as Sonner } from 'sonner';
import { CheckCircleIcon, InfoIcon, WarningIcon, XCircleIcon, SpinnerIcon } from '@phosphor-icons/react/ssr';
import { useResolvedTheme } from '@/hooks/use-resolved-theme';
const Toaster = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const theme = useResolvedTheme();
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      success: <CheckCircleIcon className="size-4" />,
      info: <InfoIcon className="size-4" />,
      warning: <WarningIcon className="size-4" />,
      error: <XCircleIcon className="size-4" />,
      loading: <SpinnerIcon className="size-4 animate-spin" />
    };
    t2 = {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      "--border-radius": "var(--radius)"
    };
    t3 = {
      classNames: {
        toast: "cn-toast"
      }
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== theme) {
    t4 = <Sonner theme={theme} className="toaster group" icons={t1} style={t2} toastOptions={t3} {...props} />;
    $[5] = props;
    $[6] = theme;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export { Toaster };